import { useParams, Link } from 'react-router-dom'
import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect, createRef } from 'react'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Card from '../../usables/small/Card'
import Modal from '../../usables/Modal'
import Input from '../../usables/small/Input'
import Button from '../../usables/small/ButtonReal'
import Select from 'react-select'

export default function Student() {
  const { id } = useParams()
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [student, setStudent] = useState({})
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [formData, setFormData] = useState({name: '', lastname: '', email: '', phone: ''})
  const [formDataG, setFormDataG] = useState({student_id: id, name: '', lastname: '', email: '', phone: ''})
  const [formDataC, setFormDataC] = useState({student_id: id, class_id: ''})
  const [formDataGC, setFormDataGC] = useState({student_id: id, guardian_id: ''})
  const [classList, setClassList] = useState([])
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)
  const modal = createRef()

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const updatePerson = () => {
    axios.patch(process.env.REACT_APP_API + `/people/${student.person.id}`, formData, config)
      .then((res)=>{
        if(res.status === 200){
          var stud = {...student}
          stud.person = res.data.person
          setStudent(stud)
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  const createGuardian = () => {
    axios.post(process.env.REACT_APP_API + '/guardian', formDataG, config)
      .then((res)=>{
        if(res.status === 200){
          var stud = {...student}
          stud.guardian.push(res.data.guardian)
          setStudent(stud)
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  // const attachGuardian = () => {
  //   axios.post(process.env.REACT_APP_API + '/guardian/attach', formDataGC, config)
  //     .then((res)=>{
  //       if(res.status === 200){
  //         window.location.reload()
  //       }
  //     })
  //   }

  const detachGuardian = () => {
    axios.post(process.env.REACT_APP_API + '/guardian/detach', formDataGC, config)
      .then((res)=>{
        if(res.status === 200){
          window.location.reload()
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  const deleteGuardian = () => {
    axios.delete(process.env.REACT_APP_API + `/guardian/${formDataGC.guardian_id}`, config)
      .then((res)=>{
        if(res.status === 200){
          window.location.reload()
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  const updateClass = () => {
    axios.post(process.env.REACT_APP_API + '/class/addtoclass', formDataC, config)
      .then((res)=>{
        if(res.status === 200){
          window.location.reload()
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + `/student/${id}`, config)
    .then(res => {
      if(res.status === 200){
        setStudent([]) //! Pašalinti prieš buildinant
        setStudent(res.data.student)
        setFormData({name: res.data.student.person.name, lastname: res.data.student.person.lastname, email: res.data.student.person.email, phone: (res.data.student.person.phone === null) ? '' : res.data.student.person.phone})
        setFormDataG({...formDataG, student_id: res.data.student.id})
        setFormDataC({...formDataC, student_id: res.data.student.id})
        // var temp = {}
        // temp.student_id = res.data.student.id
        // if(res.data.student.student_class !== null) {
        //   // temp.class_id = res.data.student.student_class.id
        //   setFormDataC({...formDataC, class_id: res.data.student.student_class.id})
        // }
        setDataLoaded({done: true, sucssess: true, items: 1})
      }
      axios.get(process.env.REACT_APP_API + '/class', config)
      .then(res => {
        if(res.status === 200){
          setClassList([]) //! Pašalinti prieš buildinant
          res.data.forEach((data) => {
            setClassList(classes => [...classes, data])
          })
        }
      })
      .catch(err => {
        setClassList([]) //! Pašalinti prieš buildinant
        setClassList(classes => [...classes, err.response.data])
        // setDataLoaded({done: true, sucssess: false, items: 0})
      })
    })    
    .catch(err => {
      setStudent([]) //! Pašalinti prieš buildinant
      setStudent(err.response.data)
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    {dataLoaded.sucssess ? <h2>{student.person.name + ' ' + student.person.lastname}</h2> : null}
    <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
    {!dataLoaded.done
    ? <Spinner />
    : dataLoaded.sucssess
      ?dataLoaded.items
        ? <>
            <div className="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5">
              <Card title='Pagrindinė informacija'>
                <ul className='divide-y divide-gray-200'>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Vardas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {student.person.name}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Pavardė
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {student.person.lastname}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          El. paštas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(student.person.email !== null) ? student.person.email : 'nėra'}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Telefonas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(student.person.phone !== null) ? student.person.phone : 'nėra'}
                      </div>
                    </div>
                  </li>
                </ul>
                {authUser().roles.admin &&
                <Modal btnText='Redaguoti' title='Redaguoti' saveText='Išsaugoti' submitFunction={() => updatePerson()}>
                  <div className='pt-5'>
                    <Input
                      label='Vardas'
                      name='name'
                      type='text'
                      value={formData.name}
                      onChange={(e)=>setFormData({...formData, name: e.target.value})}
                      />
                    <Input
                      label='Pavardė'
                      name='lastname'
                      type='text'
                      value={formData.lastname}
                      onChange={(e)=>setFormData({...formData, lastname: e.target.value})}
                      />
                    <Input
                      label='El. paštas'
                      name='email'
                      type='email'
                      value={formData.email}
                      onChange={(e)=>setFormData({...formData, email: e.target.value})}
                      />
                    <Input
                      label='Telefonas'
                      name='phone'
                      type='tel'
                      value={formData.phone}
                      onChange={(e)=>setFormData({...formData, phone: e.target.value})}
                      />
                  </div>
                </Modal>}
              </Card>
              <Card title='Globėjai'>
                <ul className='divide-y divide-gray-200'>
                  {(student.guardian.length !== 0)
                    ? student.guardian.map((guardian) => {
                      return (
                        <li key={guardian.id} className="py-3 sm:py-4">
                          <div className="flex items-center space-x-4">
                            <div className="flex-1 min-w-0">
                              <p className="text-sm font-medium text-gray-900 truncate "> {/* dark:text-white */}
                                {guardian.person.name + ' ' + guardian.person.lastname}
                              </p>
                            </div>
                            <div className="inline-flex items-center text-base font-semibold text-gray-900 "> {/* dark:text-white */}
                              <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/guardians/' + guardian.id}>Daugiau</Link>&nbsp;
                              {authUser().roles.admin && 
                              <span className='text-red-500 hover:text-red-700 cursor-pointer' onClick={() => {
                                setFormDataGC({...formDataGC, guardian_id: guardian.id})
                                modal.current.updateShow()
                              }}>Naikinti</span>}
                            </div>
                          </div>
                        </li>
                      )
                    })
                    : 'Globėjų nerasta'
                  }
                  
                </ul>
                {authUser().roles.admin && 
                <Modal btnText='Pridėti' title='Pridėti globėją' saveText='Išsaugoti' submitFunction={() => createGuardian()}>
                  <div className='pt-5'>
                    <Input
                      label='Vardas'
                      name='name'
                      type='text'
                      value={formDataG.name}
                      onChange={(e)=>setFormDataG({...formDataG, name: e.target.value})}
                      />
                    <Input
                      label='Pavardė'
                      name='lastname'
                      type='text'
                      value={formDataG.lastname}
                      onChange={(e)=>setFormDataG({...formDataG, lastname: e.target.value})}
                      />
                    <Input
                      label='El. paštas'
                      name='email'
                      type='email'
                      value={formDataG.email}
                      onChange={(e)=>setFormDataG({...formDataG, email: e.target.value})}
                      />
                    <Input
                      label='Telefonas'
                      name='phone'
                      type='tel'
                      value={formDataG.phone}
                      onChange={(e)=>setFormDataG({...formDataG, phone: e.target.value})}
                      />
                  </div>
                </Modal>}
              </Card>
              <Card title='Papildoma informacija'>
                <ul className='divide-y divide-gray-200'>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Klasė
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(student.student_class !== null) ?  <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/classes/' + student.student_class.id}>{student.student_class.name}</Link> : 'nėra'}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Auklėtojas
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {(student.student_class !== null) 
                          ? (student.student_class.teacher !== null) 
                            ? student.student_class.teacher.person.name + ' ' + student.student_class.teacher.person.lastname
                            : 'nėra'
                          : 'nėra'
                        }
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Pažymių vidurkis atėjus į mokyklą
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {student.avg_grade}
                      </div>
                    </div>
                  </li>
                  <li className="py-3 sm:py-4">
                    <div className="flex items-center space-x-4">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate ">
                          Ankstesnė mokykla
                        </p>
                      </div>
                      <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                        {student.prev_school}
                      </div>
                    </div>
                  </li>
                  
                </ul>
                {authUser().roles.admin && 
                <Modal btnText='Keisti klasę' title='Keisti klasę' saveText='Išsaugoti' submitFunction={() => updateClass()}>
                  <div className='pt-5'>
                  <label htmlFor="class">Klasė</label>
                  <Select 
                    name='class'
                    onChange={(e)=>setFormDataC({...formDataC, class_id: e.value})} 
                    defaultValue={(student.student_class !== null) ? {value: student.student_class.id, label: student.student_class.name} : null} 
                    options={
                    classList.map(classo => {
                      return ({ value: classo.id, label: classo.name })
                    })
                  } />
                  </div>
                </Modal>}
              </Card>
            </div>
            {authUser().roles.admin && 
            <Modal title='Naikinti?' saveText='Išsaugoti' displaySubmit={false} noBtn ref={modal}>
              <p>Ar norite panaikinti globėją visiškai ar tik šiam moksleiviui?</p>
              <br />
              <div className='flex gap-4 justify-center'>
                <Button text='Tik šiam' onClick={() => detachGuardian()} />
                <Button text='Visiškai' danger onClick={() => deleteGuardian()} />
              </div>
            </Modal>}
          </>
        : <ClosingAlert type='warning' message='Nerastas jokia informacija' />
      : <ClosingAlert type='error' message='Moksleivis nerastas' />
    }
    </>
  )
}